import React, { useState, useEffect } from 'react';
import { popup } from '../../utils';
import { useSearchParams } from "../../backend/navigation";

export default function DateRangePicker({ startDate, endDate, preset, onApply, onPresetChange }) {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [searchParams] = useSearchParams();
  // const [error, setError] = useState("");
  const [activePreset, setActivePreset] = useState(preset || null);

  useEffect(() => {
    setStart(startDate || '');
    setEnd(endDate || '');
    // Update active preset from prop
    setActivePreset(preset || null);
    // Clear active preset when dates are cleared from parent
    if (!startDate && !endDate && !preset) {
      setActivePreset(null);
    }
  }, [startDate, endDate, preset]);

  const formatDate = (date) => date.toISOString().split('T')[0];

  const applyPreset = (preset) => {
    const now = new Date();
    let s, e;

    switch (preset) {
      case 'this_year':
        s = new Date(now.getFullYear(), 0, 1);
        e = now;
        break;

      case 'last_year':
        s = new Date(now.getFullYear() - 1, 0, 1);
        e = new Date(now.getFullYear() - 1, 11, 31);
        break;

      case 'this_month':
        s = new Date(now.getFullYear(), now.getMonth(), 1);
        e = now;
        break;

      case 'last_month':
        s = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        e = new Date(now.getFullYear(), now.getMonth(), 0);
        break;

      case 'last_6_month':
        s = new Date(now.getFullYear(), now.getMonth() - 5, 1);
        e = now;
        break;

      default:
        return;
    }

    const formattedStart = formatDate(s);
    const formattedEnd = formatDate(e);

    setStart(formattedStart);
    setEnd(formattedEnd);
    setActivePreset(preset);
    onApply({ start: formattedStart, end: formattedEnd, preset });
  };

  const handleApply = () => {
    // if (!start || !end) {
    //   setError("Please select both start and end date.");
    //   return;
    // }
    if (new Date(end) < new Date(start)) {
      popup('Error', 'End date cannot be before start date.');
      return;
    }

    // setError("");
    setActivePreset(null);
    onApply({ start, end, preset: null });
  };

  const handleClear = () => {
    setStart('');
    setEnd('');
    setActivePreset(null);
    // setError("");
    if (onPresetChange) {
      onPresetChange(null);
    }
    onApply({ start: '', end: '', preset: null });
  };

  return (
    <div className="p-3 border rounded bg-white shadow-sm">
      {/* PRESET BUTTONS */}
      <div className="d-flex flex-wrap gap-2 mb-3">
        <button
          className={`btn ${activePreset === 'this_year' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => applyPreset('this_year')}>
          This Year
        </button>
        <button
          className={`btn ${activePreset === 'last_year' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => applyPreset('last_year')}>
          Last Year
        </button>
        <button
          className={`btn ${activePreset === 'this_month' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => applyPreset('this_month')}>
          This Month
        </button>
        <button
          className={`btn ${activePreset === 'last_month' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => applyPreset('last_month')}>
          Last Month
        </button>
        <button
          className={`btn ${activePreset === 'last_6_month' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => applyPreset('last_6_month')}>
          Last 6 Months
        </button>
      </div>

      {/* MANUAL DATE PICKERS */}
      <div className="d-flex gap-3 flex-wrap">
        <div className="d-flex flex-column">
          <label className="form-label small fw-semibold">Start Date</label>
          <input
            type="date"
            value={start}
            onChange={(e) => {
              setStart(e.target.value);
              setActivePreset(null);
              if (onPresetChange) {
                onPresetChange(null);
              }
            }}
            className="form-control"
            style={{ minWidth: '200px' }}
          />
        </div>

        <div className="d-flex flex-column">
          <label className="form-label small fw-semibold">End Date</label>
          <input
            type="date"
            value={end}
            onChange={(e) => {
              setActivePreset(null);
              setEnd(e.target.value);
              if (onPresetChange) {
                onPresetChange(null);
              }
            }}
            className="form-control"
            style={{ minWidth: '200px' }}
          />
        </div>

        <div className="d-flex align-items-end gap-2">
          <button
            className={`btn btn-primary ${
              !(start || end) ||
              (start === searchParams?.get('start_date') && end === searchParams?.get('end_date'))
                ? 'disabled'
                : ''
            }`}
            onClick={handleApply}
            disabled={
              !(start || end) ||
              (start === searchParams?.get('start_date') && end === searchParams?.get('end_date'))
            }>
            Apply
          </button>
          <button
            className={`btn btn-outline-secondary ${!(start || end) ? 'disabled' : ''}`}
            disabled={!(start || end)}
            onClick={handleClear}>
            Clear
          </button>
        </div>
      </div>

      {/* {error && <p className="text-danger small mt-2">{error}</p>} */}
    </div>
  );
}
